import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { PaywallAppSteps } from '@/pages/Paywall/components/AppStep';

import './HowItWorks.scss';

export const OnboardingPaywallHowItWorks: React.FC = () => {
  return (
    <section className="onboarding-paywall-how-it-works">
      <OnboardingTitle className="onboarding-paywall-how-it-works__title">
        How it{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          works
        </UiTypography>
      </OnboardingTitle>

      <PaywallAppSteps />
    </section>
  );
};
